// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c0c57d4d","496":"c4fcbe69","908":"928063b7"}[chunkId] + ".chunk.js";
};